module.exports = __webpack_public_path__ + "img/neurone-evaluation.c0ff1e51.gif";